// extracted by mini-css-extract-plugin
module.exports = {"offScreen":"OffScreen_offScreen__1RhKi","offScreenIn":"OffScreen_offScreenIn__iyaZW"};